var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundcloudIconsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2342_2441)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2342_2441)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2342_2441)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8113 0.34668H9.18966C4.41315 0.34668 0.541016 4.21881 0.541016 8.99533V30.6169C0.541016 35.3935 4.41315 39.2656 9.18966 39.2656H30.8113C35.5878 39.2656 39.4599 35.3935 39.4599 30.6169V8.99533C39.4599 4.21881 35.5878 0.34668 30.8113 0.34668Z",
    fill: "url(#paint0_linear_2342_2441)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2342_2441",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4263 8.37891H8.57324V31.232H31.4263V8.37891Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2342_2441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67744 24.292C9.7246 24.292 9.76451 24.2532 9.77129 24.1986L10.0276 22.1668L9.77205 20.0888C9.76444 20.0343 9.7246 19.9951 9.67744 19.9951C9.62906 19.9951 9.58785 20.0351 9.58145 20.0888L9.35742 22.1668L9.58145 24.1978C9.58785 24.2524 9.62906 24.292 9.67744 24.292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83202 23.5186C8.87833 23.5186 8.91589 23.4825 8.92267 23.4286L9.12134 22.166L8.92267 20.8799C8.91581 20.8278 8.87833 20.79 8.83202 20.79C8.78364 20.79 8.74617 20.8278 8.73932 20.8806L8.57324 22.1661L8.73932 23.4283C8.74617 23.4817 8.78364 23.5186 8.83202 23.5186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6873 19.7022C10.6812 19.6361 10.6329 19.5879 10.5728 19.5879C10.5133 19.5879 10.4648 19.6361 10.4592 19.7022L10.2451 22.1668L10.4592 24.5416C10.4648 24.6072 10.5133 24.6548 10.5728 24.6548C10.6329 24.6548 10.6812 24.6072 10.6873 24.5416L10.9296 22.1668L10.6873 19.7022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4797 24.7506C11.5498 24.7506 11.6067 24.6929 11.6136 24.6173L11.8425 22.1677L11.6136 19.6342C11.6067 19.5582 11.5498 19.501 11.4797 19.501C11.4084 19.501 11.3508 19.5582 11.3458 19.6346L11.1436 22.1677L11.3458 24.6173C11.3508 24.6929 11.4084 24.7506 11.4797 24.7506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3919 24.79C12.4737 24.79 12.5393 24.7245 12.5461 24.6368L12.7609 22.1673L12.5454 19.8167C12.5392 19.7305 12.4737 19.6641 12.3917 19.6641C12.3087 19.6641 12.2434 19.7305 12.2384 19.8175L12.0479 22.1674L12.2384 24.6369C12.2435 24.7245 12.3088 24.79 12.3919 24.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6869 22.168L13.4846 18.346C13.479 18.2492 13.4035 18.1719 13.3109 18.1719C13.2189 18.1719 13.1436 18.2491 13.138 18.346L12.959 22.168L13.138 24.6375C13.1436 24.7348 13.219 24.811 13.3109 24.811C13.4035 24.811 13.479 24.7348 13.4846 24.6375L13.6869 22.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2402 24.8152C14.3422 24.8152 14.4268 24.7305 14.4316 24.6225V24.6242L14.6206 22.1688L14.4316 17.4719C14.4268 17.3639 14.3422 17.2793 14.2402 17.2793C14.1358 17.2793 14.0519 17.3639 14.0463 17.4719L13.8799 22.1688L14.047 24.6233C14.0519 24.7305 14.1358 24.8152 14.2402 24.8152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1738 16.8672C15.059 16.8672 14.9662 16.9615 14.9615 17.0804L14.8066 22.1691L14.9615 24.5979C14.9663 24.7163 15.059 24.8099 15.1738 24.8099C15.2884 24.8099 15.3818 24.717 15.3858 24.5976V24.5988L15.5616 22.1691L15.3858 17.0804C15.3818 16.9607 15.2883 16.8672 15.1738 16.8672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1151 24.8148C16.2413 24.8148 16.3417 24.7131 16.3465 24.5821V24.5835L16.509 22.1692L16.3465 16.9096C16.3416 16.779 16.2413 16.6768 16.1151 16.6768C15.9882 16.6768 15.8862 16.779 15.8842 16.9096L15.7383 22.1692L15.8842 24.5835C15.8862 24.7131 15.9882 24.8148 16.1151 24.8148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0656 24.813C17.2019 24.813 17.3122 24.7015 17.3163 24.5602V24.5624L17.4659 22.1702L17.3163 17.0442C17.3122 16.903 17.2019 16.792 17.0656 16.792C16.9286 16.792 16.8181 16.9029 16.8141 17.0442L16.6826 22.1702L16.8149 24.5613C16.8181 24.7015 16.9286 24.813 17.0656 24.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4271 22.17L18.2917 17.231C18.2884 17.0787 18.1691 16.959 18.0211 16.959C17.8728 16.959 17.7534 17.0787 17.7503 17.232L17.6289 22.17L17.7503 24.5466C17.7534 24.6977 17.8728 24.8175 18.0211 24.8175C18.169 24.8175 18.2884 24.6977 18.2917 24.5444V24.5466L18.4271 22.17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9853 24.8218C19.1426 24.8218 19.2727 24.691 19.2751 24.5302V24.5315L19.398 22.1713L19.2751 16.294C19.2729 16.1325 19.1426 16.002 18.9853 16.002C18.8282 16.002 18.6984 16.1332 18.6951 16.2948L18.5859 22.1689L18.6951 24.5316C18.6984 24.691 18.8282 24.8218 18.9853 24.8218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9461 15.4492C19.7764 15.4492 19.6386 15.5901 19.6358 15.7618L19.5088 22.1721L19.6366 24.4975C19.6386 24.6669 19.7764 24.8074 19.9461 24.8074C20.1133 24.8074 20.2537 24.6669 20.2544 24.4946V24.4975L20.393 22.1721L20.2544 15.7618C20.2537 15.5894 20.1133 15.4492 19.9461 15.4492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8236 24.8238C20.8304 24.8245 28.5649 24.8282 28.6146 24.8282C30.1674 24.8282 31.4258 23.5543 31.4258 21.9823C31.4258 20.4113 30.1674 19.1373 28.6146 19.1373C28.2293 19.1373 27.862 19.216 27.5272 19.3587C27.3046 16.7937 25.1797 14.7822 22.5877 14.7822C21.954 14.7822 21.3362 14.9088 20.7905 15.1227C20.5781 15.2057 20.5213 15.2913 20.5195 15.4573V24.4872C20.522 24.6616 20.655 24.8066 20.8236 24.8238Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2342_2441",
    x1: 20.0005,
    y1: 0.34668,
    x2: 20.0005,
    y2: 39.2656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2342_2441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2342_2441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2342_2441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloudIconsvg);
export default __webpack_public_path__ + "static/media/soundcloud-icon.svg.dd7962f798abf564ce6b1aa96303f062.svg";
export { ForwardRef as ReactComponent };